// src/components/ClientStatusSwitch.tsx

import { forwardRef, HTMLAttributes } from 'react';
import './StatusSwitch.css';

interface Props extends HTMLAttributes<HTMLDivElement> {
    checked: boolean;
    onToggle: () => void;
}

// forwardRef porque este componente costuma ficar dentro de um <Tooltip> do
// MUI, que precisa anexar um ref no filho para se posicionar. O Tooltip
// também injeta outros props (eventos de mouse/foco, aria-*) no filho para
// saber quando mostrar/esconder -- por isso o ...rest é espalhado no mesmo
// <div> que recebe a ref, não só a ref sozinha.
const StatusSwitch = forwardRef<HTMLDivElement, Props>(({ checked, onToggle, ...rest }, ref) => {
    return (
        <div className="container" ref={ref} {...rest}>
            <label className="switch">
                <input
                    className="togglesw"
                    type="checkbox"
                    checked={checked}
                    onChange={onToggle}
                />
                <div className="indicator left"></div>
                <div className="indicator right"></div>
                <div className="button"></div>
            </label>
        </div>
    );
});

export default StatusSwitch;
